<template>
    <BreadCrumb PageTitle="Paiement d'un BESC effectué avec succès" />
    <PaiementSuccess />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PaiementSuccess from "@/components/BESC/PaiementSuccess.vue";
  
    export default defineComponent({
      name: "PaiementSuccessPage",
      components: {
        BreadCrumb,
        PaiementSuccess,
      },
    });
  </script>